import { render, staticRenderFns } from "./_name.vue?vue&type=template&id=65d01a0f&scoped=true&"
import script from "./_name.vue?vue&type=script&lang=js&"
export * from "./_name.vue?vue&type=script&lang=js&"
import style0 from "./_name.vue?vue&type=style&index=0&id=65d01a0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d01a0f",
  null
  
)

export default component.exports